import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { BlobImageDirective } from '../../../shared/directives/blob.directive';
import { RandomAvatarDirective } from '../../../shared/directives/random-value/random-avatar.directive';

export const AVATAR_SIZE = {
  SM: 'small',
  SMM: 'extra-small',
  SMMM: 'extra-small-secondary',
  MD: 'medium',
  LG: 'large',
};

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [NgIf, BlobImageDirective, RandomAvatarDirective, SvgIconComponent]
})
export class AvatarComponent implements OnInit {
  @Input() avatar: string;
  @Input() displayName: string;
  @Input() size: string = '32px';
  @Input() backgroundColor: string = '#f3f3f3';
  @Input() isChatBotAvatar: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  getFirstLetter(userName?: string): string {
    if (!userName || !userName.trim()) return 'Unknown User Name';

    const parts = userName.trim().split(/\s+/);
    const first = parts[0]?.charAt(0) || '';
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : first;

    const result = (first + last).toUpperCase();
    return result || 'Unknown User Name';
  }
}
